import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_DARK_GREEN_BUTTON,
	FONT_WT_MEDIUM,
	MOBILE_L_BP,
	COLOR_BACKGROUND_GREEN,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const TilesWrapper = styled.div`
	padding: 68px 65px 68px 65px;
	.mobileContainer {
		display: none !important;
	}
	.container {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.heading {
		text-align: center;
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-bottom: 50px;
	}
	.item {
		font-size: 20px;
		font-weight: ${FONT_WT_LIGHT};
		padding: 35px 50px 30px 50px;
		width: 376px;
		min-height: 108px;
		text-align: center;
		background-color: ${COLOR_BACKGROUND_GREEN};
		margin: 12px 15px 12px 15px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${MOBILE_L_BP}px) {
		padding: 68px 20px 68px 20px;
		.item {
			padding: 35px 10px 30px 10px;
			width: 330px;
			height: 95px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP - 1}px) {
		padding: 58px 10px 58px 10px;
		.mobileContainer {
			display: block !important;
			text-align: -webkit-center;
			border: none;
			outline: none;
		}
		.container {
			display: none;
		}
		.item {
			width: auto;
			min-height: 95px;
			margin: 0px;
			padding: 35px 12px 35px 12px;
			border-style: none !important;
		}
		.slick-dots li {
			margin: 0px -4px;
		}
		.slick-dots li button:before {
			font-size: 10px;
			color: ${COLOR_DARK_GREEN_BUTTON};
		}
		.slick-dots li.slick-active button:before {
			color: ${COLOR_DARK_GREEN_BUTTON};
		}
	}
`;
